export enum StaftPunkFeatureFlags {
    EnableNovaCandidateStartingTimeline = 'ENABLE_NOVA_CANDIDATE_STARTING_TIMELINE',
    EnableEditorVideoSupport = 'ENABLE_EDITOR_VIDEO_SUPPORT',
    EnableEditorImageSupport = 'ENABLE_EDITOR_IMAGE_SUPPORT',
    EnableEditorImageUploadSupport = 'ENABLE_EDITOR_IMAGE_UPLOAD_SUPPORT',
    EnableCrimeInNova = 'ADD_CRIME_TO_NOVA',
    EnableProgressiveProfilingDisplay = 'DATA_PROGRESSIVE_PROFILING_NOVA_DISPLAY',
    HubSpotEmailBouncedToNovaProfile = 'hubSpot-email-bounced-to-nova-profile',
    EnableContractExtensionStatusEnhancement = 'contract-extension-status-enhancement',
    EnableCurrentAddressLine2 = 'enable-candidate-profile-current-address-line2',
    EnableEmergencyContact = 'nova-emergency-contact'
}
